export const searchList = (state) => state.checkOut.CheckOutList;